<template>
    <footer class="one-footer-area pt-100">
        <div class="container">
            <div class="row">
                <div class="col-sm-6 col-lg-3">
                    <div class="footer-item">
                        <div class="footer-logo">
                            <a href="#">
                                <img src="../../assets/img/jill_icon_blue.png" alt="Logo">
                            </a>
                            <p>Plotix.es<br> Mijas Costa | Málaga</p>

                            <ul>
                                <li>
                                    <a target="_blank" href="https://www.facebook.com/">
                                        <i class='bx bxl-facebook'></i>
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" href="https://www.twitter.com/">
                                        <i class='bx bxl-twitter'></i>
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" href="https://www.linkedin.com/in/michel-conesa-b4647b22/">
                                        <i class='bx bxl-linkedin'></i>
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" href="https://www.instagram.com/ploti.x/">
                                        <i class='bx bxl-instagram'></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <div class="footer-item">
                        <div class="footer-address">
                            <h3>Sobre nosotros</h3>
                            <ul>
                                <li>
                                    <i class='bx bx-wrench'></i>
                                    <a href="#contact-strip">Servicio técnico y reparación</a>
                                </li>
                                <li>
                                    <i class='bx bx-shield-quarter'></i>
                                    <a href="#contact-strip">Mantenimiento preventivo</a>
                                </li>
                                <li>
                                    <i class='bx bx-cog'></i>
                                    <a href="#contact-strip">Instalación y calibración de equipos</a>
                                </li>
                                <li>
                                    <i class='bx bx-droplet'></i>
                                    <a href="#contact-strip">Venta de tintas y repuestos</a>
                                </li>
                                <li>
                                    <i class='bx bx-support'></i>
                                    <a href="#contact-strip">Soporte remoto y telefónico</a>
                                </li>
                                <li>
                                    <i class='bx bx-send'></i>
                                    <a href="#contact-strip">Solicitar asistencia</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <div class="footer-item">
                        <div class="footer-address">
                            <h3>Contacto</h3>
                            <ul>
                                <li>
                                    <i class='bx bx-phone-call'></i>
                                    <a href="tel:+34 623 61 51 28">+34 623 61 51 28</a>
                                </li>

                                <li>
                                    <i class='bx bx-message-square-detail'></i>
                                    <a href="mailto:serviciotecnico@plotix.es">serviciotecnico@plotix.es</a>
                                </li>
                                <li>
                                    <i class='bx bx-current-location'></i>
                                    Base en Málaga · Servicio en toda España
                                </li>
                                <li>
                                    <i class='bx bx-planet'></i>
                                    Soporte remoto y desplazamiento in situ
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <div class="footer-item">
                        <div class="footer-address">
                            <h3>Políticas de empresa</h3>
                            <ul>
                                <li>
                                    <i class='bx bx-file'></i>
                                    <a href="/sobrenosotros">Política de privacidad</a>
                                </li>
                                <li>
                                    <i class='bx bx-lock-alt'></i>
                                    <a href="/sobrenosotros">Política de cookies</a>
                                </li>
                                <li>
                                    <i class='bx bx-book-alt'></i>
                                    <a href="/sobrenosotros">Aviso legal</a>
                                </li>
                                <li>
                                    <i class='bx bx-shield'></i>
                                    <a href="/sobrenosotros">Condiciones del servicio</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="copyright-area">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="copyright-item">
                            <ul>
                                <li>
                                    <a href="#" target="_blank">
                                        <img src="../../assets/img/footer/visa.jpg" alt="Method">
                                    </a>
                                </li>
                                <li>
                                    <a href="#" target="_blank">
                                        <img src="../../assets/img/footer/master-card.jpg" alt="Method">
                                    </a>
                                </li>
                                <li>
                                    <a href="#" target="_blank">
                                        <img src="../../assets/img/footer/paypal.jpg" alt="Method">
                                    </a>
                                </li>
                                <li>
                                    <a href="#" target="_blank">
                                        <img src="../../assets/img/footer/skrill.jpg" alt="Method">
                                    </a>
                                </li>
                                <li>
                                    <a href="#" target="_blank">
                                        <img src="../../assets/img/footer/master-card2.jpg" alt="Method">
                                    </a>
                                </li>
                                <li>
                                    <a href="#" target="_blank">
                                        <img src="../../assets/img/footer/visa2.jpg" alt="Method">
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="copyright-item">
                            <p>&copy; {{ currentYear }} Plotix</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            currentYear: new Date().getFullYear(),
        };
    }
}
</script>